import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Helmet } from "react-helmet";

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return (
      <div className="cart-container">
        <h1 className="cart-title">Το Καλάθι σας</h1>
        <div className="cart-empty">
          <p>Το καλάθι σας είναι άδειο</p>
          <Link to="/" className="btn btn-primary">
            Συνεχίστε τις Αγορές
          </Link>
        </div>
      </div>
    );
  }

  const handleCheckout = () => {
    navigate('/checkout');
  };

  return (
    <>
      <Helmet>
        <title>Sororin - Κατάστημα Ομορφιάς</title>
        <meta name="description" content="Sororin - Κατάστημα Ομορφιάς με προϊόντα υψηλής ποιότητας. Ανακαλύψτε την πολυτελή συλλογή μας από προϊόντα περιποίησης και ομορφιάς." />
      </Helmet>

      <div className="cart-container">
      <h1 className="cart-title">Το Καλάθι σας</h1>
      
      <div className="cart-items">
        {cartItems.map(item => (
          <div key={item.id} className="cart-item">
            <img src={item.image} alt={item.name} className="cart-item-image" />
            
            <div className="cart-item-details">
              <h3>{item.name}</h3>
              <p className="cart-item-price">€{item.price.toFixed(2)}</p>
              
              <div className="cart-item-actions">
                <div className="quantity-controls">
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    className="quantity-btn"
                    disabled={item.quantity <= 1}
                  >
                    -
                  </button>
                  <span className="quantity-display">{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    className="quantity-btn"
                  >
                    +
                  </button>
                </div>
                
                <button
                  onClick={() => removeFromCart(item.id)}
                  className="remove-btn"
                >
                  Αφαίρεση
                </button>
              </div>
            </div>
            
            <div className="cart-item-total">
              <strong>€{(item.price * item.quantity).toFixed(2)}</strong>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <div className="cart-total">
          <span>Σύνολο:</span>
          <span>€{getCartTotal().toFixed(2)}</span>
        </div>
        
        <div className="product-actions" style={{ marginTop: '2rem' }}>
          <Link to="/" className="btn btn-secondary">
            Συνεχίστε τις Αγορές
          </Link>
          <button onClick={handleCheckout} className="btn btn-primary">
            Ολοκλήρωση Παραγγελίας
          </button>
        </div>
      </div>
    </div>
  
    </>);
}

export default Cart;